
 $(document).ready(function () {
    $(".sssss").css("display", "none")

   
  });
